import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CiHeart } from "react-icons/ci";
import { IconButton, Box, Modal, Rating } from "@mui/material";
import { Card } from "@material-tailwind/react";
import { IoEyeSharp } from "react-icons/io5";
import { openWhislist } from "../../Redux/Action/action";
import { useDispatch, useSelector } from "react-redux";
import "../style/responsive.css";
import { IKImage } from "imagekitio-react";
import { IoClose } from "react-icons/io5";
import Eyes from "../ShopItems/Eyes";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaHeart } from "react-icons/fa";
import { whislistDataAction } from "../../Redux/Action/whislistDataAction";

const AllItem = React.memo((props) => {

  const { item } = props;
  const [openImgComp, setOpenImgComp] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLiked, setIsLiked] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allWishListData = useSelector(state => state.whislistDataReducer.allWishList)

  useEffect(() => {
    setIsLiked(allWishListData.includes(item?.id));
  }, [item?.id, allWishListData]);

  const handleOpenUserPage = (productId) => {
    const existingIds = JSON.parse(localStorage.getItem("productids")) || [];
    
    if(!existingIds.includes(productId)){
      existingIds.push(productId);
      localStorage.setItem("productids", JSON.stringify(existingIds));
      dispatch(whislistDataAction(existingIds))
    }
    dispatch(openWhislist(true));

  };


  const handleOpenImgComp = () => {
    setSelectedItem(item?.id);
    setOpenImgComp(true);
  };

  const handleCloseImgComp = () => {
    setOpenImgComp(false);
  };

  const navigateShop = (e) => {
    if (item?.id) {
      navigate(`/shop?id=${item?.id}`);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const handleLike = () => {
    setIsLiked(allWishListData);
    handleOpenUserPage(item?.id);
  };

  return (
    <div className="all-item-card">
      <Modal
        open={openImgComp}
        onClose={handleCloseImgComp}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="custom-model"
      >
        <Box className="eyes-box">
          <div className="flex justify-end ">
            <IconButton
              onClick={handleCloseImgComp}
              className="text-3xl  mt-5"
              style={{ backgroundColor: "white" }}
            >
              <IoClose />
            </IconButton>
          </div>
          <Eyes style={{ marginTop: "0 !important" }} itemId={selectedItem} />
        </Box>
      </Modal>

      <Card
        className=" flex justify-center "
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
        key={item?.id}
      >
        <div
          className="rounded overflow-hidden mt-2 p-0 "
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            height: "97%",
            width: "100%",
          }}
        >
          <div className="md:grid-cols-2 relative hasti">
            <div className="img-hover-zoom--slowmo allArrivalCard">
              {item?.prdimg && typeof item?.prdimg.toString() === "string" && (
                <IKImage
                  src={JSON.parse(item?.prdimg)[0]?.url}
                  style={{ width: "100%", height: "100%" }}
                  className=" cursor-pointer"
                  onClick={navigateShop}
                />
              )}

            {item?.prddiscount === "enable" && (
              <p className="label1">{item?.discountlable}</p>
            )}

              <p
                onClick={navigateShop}
                className="addToCartText absolute lg:left-full text-center w-full transform   transition-opacity duration-300 bg-black text-white px-4 py-2  cursor-pointer"
              >
                Read More
              </p>
              <IconButton
                aria-label="delete"
                className="IoEyeSharp"
                onClick={handleOpenImgComp}
              >
                <IoEyeSharp style={{ fontSize: "20px" }} />
              </IconButton>
            </div>
            <IconButton
              aria-label="like"
              className="heartIcons"
              onClick={() => {
                handleLike();
              }}
            >
              {isLiked ? (
                <FaHeart style={{ fontSize: "15px", color: "rgb(39 39 39)" }} />
              ) : (
                <CiHeart style={{ fontSize: "20px" }} />
              )}
            </IconButton>
            <div className="m-2">
              <div
                className="text-xl text-font mt-3 overflow-hidden flex justify-between  "
                style={{ color: " rgb(157 68 28 )" }}
              >
                <div className="truncate normal-case">{item?.prdname}</div>
              </div>
              <div className="flex justify-between overflow-hidden">
                <div className="text-xs">Price On Request</div>
                <span>
                  {item?.rating ? (
                    <span>
                      <Rating
                        name="read-only"
                        value={item?.rating}
                        size="small"
                      />
                      {/* <Rating
                        readonly
                        value={props.rating}
                      /> */}
                    </span>
                  ) : (
                    <span></span>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
});

export default AllItem;
